import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/react-hooks';
import { SEARCH_HOTELS_AUTOCOMPLETE } from 'graphql/queries/getHotels';
import { Row, Form } from 'antd';
import { useHistory } from 'react-router-dom';
import {
  Alert,
  Title,
  Button,
  RowCustom,
  DropdownClickOutside,
  ContainerCustom,
  AutoCompletePortal,
  DeviceBreakpoint,
  AutoCompletePortalMobile,
  DateRangePickerWrapper,
} from 'components';
import moment from 'moment';

import { LocationSVG, CalendarSVG, UserSVG } from 'lib/icons';
import AlertSVG from 'assets/icons/Alert.svg';
import {
  AutoCompleteWrapper,
  SearchBar,
  DatePickerContainer,
  RangePickerTransparent,
  BtnCounter,
  TitleSearchDrop,
  DropBtnStyles,
  AirbnbDatePickerContainer,
} from './SearchBarPanel.styles';
import Calendar from './Calendar';

const pluralize = require('numeralize-ru').pluralize;

const SearchBarPanel = ({
  regionName,
  autoFocus = false,
  margin,
  slugValue,
}) => {
  const intl = useIntl();

  const [guestNumber, setGuestNumber] = useState({
    adults: 2,
    children: 0,
    infants: 0,
  });

  React.useEffect(() => {
    console.log('ACTION guestNumber', guestNumber);
  }, [guestNumber]);

  const [searchInputValue, setSearchInputValue] = useState({
    region: {
      id: null,
      value: '',
      slug: slugValue ? slugValue : null,
    },
    checkinDate: '',
    checkoutDate: '',
    adults: guestNumber.adults,
    children: guestNumber.children,
    infants: guestNumber.infants,
    isCalendarReset: false,
  });

  React.useEffect(() => {
    console.log('ACTION dataAutocomplete se ', searchInputValue);
  }, [searchInputValue]);

  const [searchResult, setSearchResult] = useState([]);

  const {
    loading: loadingAutocomplete,
    error: errorAutocomplete,
    data: dataAutocomplete,
  } = useQuery(SEARCH_HOTELS_AUTOCOMPLETE, {
    variables: {
      lang: `${localStorage.language ? localStorage.language : 'en'}`,
      searchString: searchInputValue.region.value,
    },
  });

  const [isCalendarOpen, setDateFocus] = useState(autoFocus);

  const openCalendar = () => {
    setDateFocus(true);
  };
  const closeCalendar = () => {
    setDateFocus(false);
  };

  const onSelectSearchAutocomplete = (id, title, slug) => {
    openCalendar();

    setSearchInputValue({
      ...searchInputValue,
      region: {
        id,
        value: title,
        slug,
      },
    });
  };
  // Autocomplete method end

  const onChangeDate = (startDate, endDate) => {
    console.log('123', startDate, endDate);
    setSearchInputValue(() => ({
      ...searchInputValue,
      isCalendarReset: false,
    }));

    if (startDate && !endDate) {
      setSearchInputValue(() => ({
        ...searchInputValue,
        checkinDate: moment(startDate._d).format('YYYY-MM-DD'),
        isCalendarReset: false,
      }));
    }

    if (startDate && endDate) {
      setSearchInputValue(() => ({
        ...searchInputValue,
        checkinDate: moment(startDate._d).format('YYYY-MM-DD'),
        checkoutDate: moment(endDate._d).format('YYYY-MM-DD'),
        isCalendarReset: false,
      }));
    }

    if (!startDate && !endDate) {
      setSearchInputValue({
        ...searchInputValue,
        checkinDate: null,
        checkoutDate: null,
      });
    }
  };

  useEffect(() => {
    if (
      !loadingAutocomplete &&
      dataAutocomplete &&
      dataAutocomplete.regionList
    ) {
      console.log('dataAutocomplete: ', dataAutocomplete);
      console.log('dataAutocomplete er: ', errorAutocomplete);

      setSearchResult(
        dataAutocomplete.regionList.map(
          ({ region: { id, regionType, slug }, name, parents }) => ({
            id,
            slug,
            title: name,
            subtitle: parents,
            type: regionType.name,
            icon: regionType.icon,
          })
        )
      );
    }
  }, [loadingAutocomplete, dataAutocomplete]);

  const [isAlertShown, setIsAlertShown] = useState(false);

  const history = useHistory();
  const [redirect, setRedirect] = useState(false);

  // Autocomplete method start
  const onChangeSearchAutocomplete = (e) => {
    setIsAlertShown(false);
    setSearchInputValue({
      ...searchInputValue,
      region: {
        ...searchInputValue.region,
        value: e.target.value,
      },
    });
  };

  React.useEffect(() => {
    console.log('redirect: ', redirect);
  }, [redirect]);

  const onSubmitSearch = () => {
    const {
      region: { id: regionId, slug },
      checkinDate,
      checkoutDate,
    } = searchInputValue;

    const { adults, children, infants } = guestNumber;
    console.log('ACTION REGION', slug);
    if (!slug) {
      setIsAlertShown(true);
    } else {
      // console.log('ACTION checkinDate', checkinDate);
      console.log(
        'ACTION searchInputValue',
        regionId,
        checkinDate,
        checkoutDate,
        adults,
        children,
        infants
      );

      const params = {
        checkinDate,
        checkoutDate,
        adults: adults === 0 ? 2 : adults,
        children,
        infants,
      };

      const urls = {
        checkinDate: `checkindate=${checkinDate}`,
        checkoutDate: `&checkoutdate=${checkoutDate}`,
        adults: `&adults=${adults === 0 ? 2 : adults}`,
        children: `&children=${children}`,
        infants: `&children=${infants}`,
      };

      let url = `/${localStorage.language}/search/${slug}?`;

      for (let prop in params) {
        if (params[prop]) {
          url += urls[prop];
        }
      }

      window.location.href = url;

      setRedirect(true);
    }
  };

  return (
    <SearchBar
      width1440="100%"
      width="93%"
      displayLaptop="block"
      style={{ position: 'relative' }}
      margin={margin}
    >
      {/* <SearchSVG /> */}

      {isAlertShown && (
        <Alert
          bg="rgba(241, 37, 61, .6)"
          padding="14px 20px"
          height="46px"
          topTablet="-65px"
          text={intl.formatMessage({
            id: 'error-message.region-not-choosen',
          })}
          icon={AlertSVG}
        />
      )}

      <AutoCompleteWrapper
        width="28vw"
        widthLaptop="100%"
        height="50px"
        marginLaptop="30px 0"
      >
        <LocationSVG />
        <DeviceBreakpoint tabletTo1100Hidden style={{ width: '100%' }}>
          {/* <div style={{ border: '3px solid red' }}> */}
          <AutoCompletePortal
            dropContentLeftPosition="-200px"
            bgInput="transparent"
            inputHeight="50px"
            placeholderColor="white"
            dropContentLeftPosition="-193px"
            dropWrapperWidth="100%"
            dropContainerHeight="315px"
            dropContainerWidth="520px"
            placeholder={
              regionName
                ? regionName
                : intl.formatMessage({
                    id: 'filters.city',
                  })
            }
            name="region"
            value={searchInputValue.region.value}
            options={[...searchResult]}
            onChange={onChangeSearchAutocomplete}
            onSelect={onSelectSearchAutocomplete}
          />
          {/* </div> */}
        </DeviceBreakpoint>
        <DeviceBreakpoint tabletFrom1100Hidden style={{ width: '85%' }}>
          <div
            style={{
              // width: '115px',
              // border: '3px solid green',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <AutoCompletePortalMobile
              dropContentLeftPosition="-42vw"
              dropContLeft="-174px"
              placeholderColor="white"
              bgInput="transparent"
              dropContainerHeight="315px"
              dropWrapperWidth="100%"
              dropContainerWidth="329px"
              placeholder={
                regionName
                  ? regionName
                  : intl.formatMessage({
                      id: 'filters.city',
                    })
              }
              name="region"
              value={searchInputValue.region.value}
              options={[...searchResult]}
              onChange={onChangeSearchAutocomplete}
              onSelect={onSelectSearchAutocomplete}
            />
          </div>
        </DeviceBreakpoint>
      </AutoCompleteWrapper>

      <AutoCompleteWrapper
        width="25vw"
        widthLaptop="100%"
        marginLaptop="30px 0"
        position="relative"
        zindex="100"
      >
        <CalendarSVG />
        <AirbnbDatePickerContainer>
          <DateRangePickerWrapper
            autoFocus={isCalendarOpen}
            onChangeDate={onChangeDate}
            isCalendarReset={searchInputValue.isCalendarReset}
          />
        </AirbnbDatePickerContainer>
      </AutoCompleteWrapper>
      <ContainerCustom display="flex" align="center">
        <DropdownClickOutside
          dropBtnMarginLaptop="0"
          dropWrapperWidth1100="50%"
          dropBtnWidth="21vw"
          dropBtnWidthLaptop="100%"
          dropBtnHeight="50px"
          dropBtnColor="red"
          dropBtnBg="rgba(211, 211, 211, 0.25)"
          dropBtnBlur="blur(20px)"
          dropBtnBorderRadius="10px"
          dropBtnPadding="0 25px"
          dropBorderWrapper="transparent"
          btnTitle={
            guestNumber.adults > 0 ? (
              <DropBtnStyles>
                <RowCustom flexFlow="nowrap" align="middle">
                  <UserSVG />
                  <Title
                    overflow="hidden"
                    textOverflow="ellipsis"
                    size="16px"
                    margin="0 0 0 17px"
                    color="#ffffff"
                  >
                    {localStorage.language === 'ru'
                      ? `${
                          +guestNumber.adults + +guestNumber.children
                        } ${pluralize(
                          +guestNumber.adults + +guestNumber.children,
                          'Гость',
                          'Гостя',
                          'Гостей'
                        )}`
                      : `${+guestNumber.adults + +guestNumber.children} ${
                          +guestNumber.adults + +guestNumber.children === 1
                            ? 'Guest'
                            : 'Guests'
                        }`}
                  </Title>
                </RowCustom>
              </DropBtnStyles>
            ) : (
              <Row align="middle">
                <DropBtnStyles>
                  <UserSVG />
                </DropBtnStyles>
                <Title size="16px" margin="0 0 0 17px" color="#ffffff">
                  {intl.formatMessage({
                    id: 'main-page.guest-number',
                  })}
                </Title>
              </Row>
            )
          }
          margin="0 0 0 40px"
        >
          <ContainerCustom padding="15px">
            <ContainerCustom display="flex">
              <Title width="100px">
                {' '}
                {intl.formatMessage({
                  id: 'main-page.guests.adults',
                })}
                :
              </Title>
              <BtnCounter
                onClick={() =>
                  setGuestNumber({
                    ...guestNumber,
                    adults:
                      guestNumber.adults - 1 < 0 ? 0 : --guestNumber.adults,
                  })
                }
              >
                -
              </BtnCounter>

              <Title
                width="30px"
                center
                display="flex"
                align="center"
                justify="center"
              >
                {guestNumber.adults}
              </Title>
              <BtnCounter
                onClick={() =>
                  setGuestNumber({
                    ...guestNumber,
                    adults: ++guestNumber.adults,
                  })
                }
              >
                +
              </BtnCounter>
            </ContainerCustom>
            <br />
            <ContainerCustom display="flex">
              <Title width="100px">
                {intl.formatMessage({
                  id: 'main-page.guests.children',
                })}
                :
              </Title>
              <BtnCounter
                onClick={() =>
                  setGuestNumber({
                    ...guestNumber,
                    children:
                      guestNumber.children - 1 < 0 ? 0 : --guestNumber.children,
                  })
                }
              >
                -
              </BtnCounter>
              <Title width="30px" center>
                {guestNumber.children}
              </Title>
              <BtnCounter
                onClick={() =>
                  setGuestNumber({
                    ...guestNumber,
                    children: ++guestNumber.children,
                  })
                }
              >
                +
              </BtnCounter>
            </ContainerCustom>
            <br />
            <ContainerCustom display="flex">
              <Title width="100px">
                {intl.formatMessage({
                  id: 'main-page.guests.infants',
                })}
                :
              </Title>
              <BtnCounter
                onClick={() =>
                  setGuestNumber({
                    ...guestNumber,
                    infants:
                      guestNumber.infants - 1 < 0 ? 0 : --guestNumber.infants,
                  })
                }
              >
                -
              </BtnCounter>
              <Title width="30px" center>
                {guestNumber.infants}
              </Title>
              <BtnCounter
                onClick={() =>
                  setGuestNumber({
                    ...guestNumber,
                    infants: ++guestNumber.infants,
                  })
                }
              >
                +
              </BtnCounter>
            </ContainerCustom>
          </ContainerCustom>
        </DropdownClickOutside>
        <Button
          width="50%"
          height="50px"
          heightMobL="50px"
          heightSm="50px"
          onClick={onSubmitSearch}
          size="16px"
          padding="15px 38px"
          margin="0 0 0 35px"
          widthMobL="50%"
          marginMobL="0 0 0 13px"
          primary
        >
          {intl.formatMessage({
            id: 'buttons.search',
          })}
        </Button>
      </ContainerCustom>
    </SearchBar>
  );
};

export { SearchBarPanel };
